import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors, dimensions } from "@styles";

export const nav = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80rem;
  padding: 2rem;
`;

export const ul = css`
  display: flex;
  height: 100%;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const navContainer = css`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const navLink = css`
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  color: ${colors.grey.darkFamily.dark};
  height: 80%;

  &&& {
    font-weight: ${typography.h3FontWeight};
  }

  svg path {
    fill: ${colors.grey.darkFamily.dark};
  }

  &:hover,
  &:focus {
    color: ${colors.green.base};
    path {
      fill: ${colors.green.base};
    }
  }
`;

export const homeLink = css`
  display: inline-flex;
  height: 100%;
  align-items: center;
  margin-right: 2.8125rem;
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    margin-right: 1rem;
  }
`;

export const dropdownBox = css`
  position: fixed;
  background: ${colors.white};
  padding: 3rem 1rem 1.5rem 1.75rem;
  width: 60rem;
  margin-top: 4.75rem;
  border-radius: 0 0 0.5rem 0.5rem;
  box-shadow: 0 8px 8px rgb(0, 0, 0, 15%) !important;
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.25rem;
  }

  @media only screen and (max-width: ${dimensions.tablet}) {
    padding-top: 0.25rem;
  }
`;

export const navLogo = css`
  display: block;
  margin-top: 0.45rem;
  height: 1.75rem;
  width: 9rem;
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    width: 2rem;
  }
`;

export const signInButton = css`
  margin-right: 1.75rem;
`;

export const navButton = css`
  border-radius: 0.5rem !important;
  &:hover {
    box-shadow: 0 4px 4px rgb(0, 0, 0, 25%) !important;
  }
`;
